import clsx from 'clsx';
import type { MouseEventHandler } from 'react';
import useTestTag from '../../../../common/hooks/use-test-tag';
import { IconButton } from '../../../button/button';
import { OdinIconSize } from '../../../odin-icon/odin-icon.component';

interface FilterChipProps {
  text?: string;
  onClear: MouseEventHandler<HTMLButtonElement>;
}

const FilterChip = ({ text, onClear }: FilterChipProps) => {
  const tagCreator = useTestTag('filter-chip');

  const currentValueStyles = clsx(
    'flex items-center justify-between grow min-w-0 text-primary-1',
    'border border-transparent rounded-full px-3 text-xs h-5 mr-2',
    {
      'border-primary-1!': text,
    }
  );

  return (
    <div
      className={currentValueStyles}
      title={text}
      ref={tagCreator(text ? text.replace(/\s+/g, '-').toLowerCase() : 'filter-value')}
    >
      <p className="truncate">{text}</p>
      {text && <IconButton onClick={onClear} icon="X" iconSize={OdinIconSize.ExtraSmall} />}
    </div>
  );
};

export default FilterChip;
